module.exports = __webpack_public_path__ + "static/media/campusWholeMap_colleges.24316543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/builder/gameUniversity/campusWholeMap_colleges.png
// module id = 2304
// module chunks = 0